module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/bg_nagai01-6f27b4796ce4f8ab2fcfec6cb701cabb.jpg";